// Completion helpers for the capture wizard.
//
// Completion must be decided by WHICH images exist, not by images.length. A duplicate
// upload used to inflate the count and satisfy the length gates with a step still
// missing - uid JGGR47927082 submitted without upper_jaw that way.
//
// These work for both the full 6-step scan (Scan/steps.js) and any partial step list.

export const FACE_TITLE = "Face"

// Face is captured FIRST, at activeImageSide === -1, even though generateSteps() puts it
// LAST in the array (Scan/steps.js). Shoot renders PreviewFace only for -1, so routing to
// steps.findIndex("Face") would open the teeth camera with the wrong overlay.
export const captureIndexOf = (steps = [], title) =>
    title === FACE_TITLE ? -1 : steps.findIndex((step) => step.title === title)

export const missingSteps = (steps = [], images = []) =>
    steps.filter((step) => !images.some((img) => img.title === step.title))

// steps.length > 0 is deliberate: an empty step list must NOT read as "complete".
export const isScanComplete = (steps = [], images = []) =>
    steps.length > 0 && missingSteps(steps, images).length === 0

// The first step still missing, as an activeImageSide that Shoot understands.
// Face first (the real capture order), then array order. Returns null when complete.
export const nextCaptureIndex = (steps = [], images = []) => {
    const missing = missingSteps(steps, images)
    if (!missing.length) return null
    const target = missing.find((step) => step.title === FACE_TITLE) || missing[0]
    return captureIndexOf(steps, target.title)
}
